import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import InfoBubble from 'components/common/info_bubble';
import { ReactComponent as ShippingIcon } from 'images/sustainability/shipping.svg';
import { ReactComponent as LeafIcon } from 'images/sustainability/leaf.svg';
import { SUSTAINABILITY, isFeatureEnabled } from 'utilities/features';
import { SHIPPING_QUOTE_TYPES } from 'constants/enums';

const ShippingBubble = (props) => {
  const { quote, expeditedAvailable } = props;

  if (!quote) return null;

  const { verb, sq_type, expedited } = quote;

  const theme = useTheme();
  const { t } = useTranslation();

  const getEstimateText = ({ min, max, time_unit }) => {
    // if min is nil or 0, show max
    if (!min || min === 0) {
      return t('productPage.shippingEstimateSingle', {
        max,
        timeUnit: t(`shipping.shippingEstimate.timeUnits.${time_unit}.one`),
      });
    }

    // Otherwise, show a range
    return t('productPage.shippingEstimate', {
      min,
      max,
      timeUnit: t(`shipping.shippingEstimate.timeUnits.${time_unit}.other`),
    });
  };

  return (
    <InfoBubble
      icon={<ShippingIcon />}
      variant="generic"
      spacing={2.5}
      iconSpacing={5}
    >
      <p className="medium-30">
        {sq_type === SHIPPING_QUOTE_TYPES.EXTENDED
          ? t('productPage.extendedShippingEstimateWithStandard', {
              verb: t(`shipping.shippingEstimate.verbs.${verb}`),
              shippingEstimate: getEstimateText(quote),
            })
          : t('productPage.freeShippingEstimate', {
              est: getEstimateText(quote),
            })}
      </p>
      <p className="paragraph-10" style={{ marginTop: theme.spacing(0.5) }}>
        {expeditedAvailable
          ? t('productPage.expeditedShippingEstimate', {
              est: getEstimateText(expedited),
            })
          : t('productPage.expeditedUnavailable')}
      </p>
      {isFeatureEnabled(SUSTAINABILITY) && (
        <p
          className="medium-10"
          style={{ color: '#29A33D', marginTop: theme.spacing(0.5) }}
        >
          <LeafIcon
            style={{
              fill: '#29A33D',
              marginRight: '4px',
              verticalAlign: 'middle',
            }}
          />
          {t('productPage.carbonNeutralShipping')}
        </p>
      )}
    </InfoBubble>
  );
};

export default ShippingBubble;
